import React from 'react';
import ComingSoon from '../components/ComingSoon';

export default function ContentCreators() {
  return (
    <ComingSoon
      title="For Content Creators"
      blurb="Tools and marketplace features tailored to content creators are on the way."
    />
  );
}
